import React, { useEffect } from 'react'

// styling
import './hero.css'
// images
import HeroImage from '../../images/hero-image.svg'
import heroImageSmall from '../../images/hero-image.svg'
import facebookLogo from '../../images/facebook.svg'
import twitter from '../../images/twitter.svg'
import instagram from '../../images/instagram.svg'
import discord from '../../images/discord.svg'
import opensea from '../../images/opensea.svg'
import rarity from "../../images/rarity.png";

const Hero = () => {
    useEffect(() => {
        const setTime = () => {
            var deadline = new Date('Feb 04, 2022 23:30:00 GMT').getTime()
            var x = setInterval(function () {
                var now = new Date().getTime()
                var t = deadline - now
                var days = Math.floor(t / (1000 * 60 * 60 * 24))
                var hours = Math.floor(
                    (t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                )
                var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60))
                var seconds = Math.floor((t % (1000 * 60)) / 1000)
                if (days % 10 === days) {
                    days = '0' + days.toString()
                }
                if (hours % 10 === hours) {
                    hours = '0' + hours.toString()
                }
                if (minutes % 10 === minutes) {
                    minutes = '0' + minutes.toString()
                }
                if (seconds % 10 === seconds) {
                    seconds = '0' + seconds.toString()
                }
                // console.log(days / 10)
                document.getElementById('timerDemo').innerHTML =
                    days + ' : ' + hours + ' : ' + minutes + ' : ' + seconds
                if (t < 0) {
                    clearInterval(x)
                    document.getElementById('timerDemo').innerHTML =
                        '00 : 00 : 00 : 00 '
                }
            }, 1000)
        }
        setTime()

        return () => {}
    }, [])

    return (
        <div className='hero-section'>
            <img
                className='hero-image'
                src={HeroImage}
                alt='Legend of Shangu'
            />
            <div className='hero-title'>
                <div className='hero-title-overlay'>
                    <p>
                        Welcome to the <span>Legends Of Shangu</span>
                    </p>
                    <div className='hero-countdown'>
                        <h3>Countdown to Whitelist 1</h3>
                        <h4 id='timerDemo'>04 : 22 : 20 : 22 </h4>
                        <div className='hero-countdown-con'>
                            <p>Days</p>
                            <p>Hours</p>
                            <p>Minutes</p>
                            <p>Seconds</p>
                        </div>
                    </div>
                </div>
                <div className='social-media'>
                    <a 
                    href="https://www.twitter.com/Legendsofshangu"
                    target="_blank"
                    
                    >

                        <img src={twitter} alt='twitter' />
                    </a>
                    <a href="https://instagram.com/Legendsofshangu" target="_blank">
                        <img src={instagram} alt='instagram' />
                    </a>
                    <a href="https://discord.gg/legendsofshangu" target="_blank"> 
                        <img src={discord} alt='discord' />
                    </a>
                    {/* <a href="https://raritysniper.com/" target="_blank">
                        <img src={rarity} alt='rarity'/>
                    </a> */}
                    <a href="https://opensea.io/collection/losbydavidhuynh" target="_blank">
                        <img src={opensea} alt='opensea' />
                    </a>
                    
                </div>
            </div>
        </div>
    )
}

export default Hero
